import React from 'react';
//import Cls from './Cls';
import PageButton from './PageButton';
import ClassCardBig from './ClassCardBig';

class ClassesList extends React.Component {
    buttonToLink = {
        fontSize: '1em',
        textAlign: 'left',
        color: 'black',
        fontWeight: 'bold',
        background: 'none',
        margin: 0,
        padding: 0,
        border: 'none',
        cursor: 'pointer'

    }

    state = {
        courseSort: "NONE",
        classNumberSort: "NONE",
        dateSort: "ASC",
        locationSort: "NONE",
        page: 0,
        itemsPerPage: 25,
    }

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
    }

    getNextSortMode(sortmode) {
        switch (sortmode) {
            case "ASC":
                return "DESC";
            case "DESC":
                return "NONE";
            case "NONE":
                return "ASC";
            default:
        }
    }

    gotoPage(page) {
        this.setState({ page: page });
    }

    updateSort(sort) {
        let newState = {};
        for (const [key, value] of Object.entries(this.state)) {
            if (key.slice(-4) === "Sort") {
                if (key === sort) {
                    newState[key] = this.getNextSortMode(value);
                } else {
                    newState[key] = "NONE";
                }
            }
        }
        this.setState(newState);
    }

    handleChange(e) {
        switch (e.target.id) {
            case "btnCourseSort":
                this.updateSort("courseSort");
                break;
            case "btnClassNumberSort":
                this.updateSort("classNumberSort");
                break;
            case "btnDateSort":
                this.updateSort("dateSort");
                break;
            case "btnLocationSort":
                this.updateSort("locationSort");
                break;
            default:
                console.log(e.target.id);
        }
    }

    getSortedBy() {
        for (const [key, value] of Object.entries(this.state)) {
            if (key.slice(-4) === "Sort") {
                if (value !== "NONE") {
                    return key;
                }
            }
        }
    }

    render() {

        let classes = this.props.classes;
        //sort
        switch (this.getSortedBy()) {
            case "courseSort":
                if (this.state.courseSort === "ASC") {
                    classes.sort((a, b) => (a.S + a.CN > b.S + b.CN) ? 1 : ((b.S + b.CN > a.S + a.CN) ? -1 : 0));
                } else {
                    classes.sort((b, a) => (a.S + a.CN > b.S + b.CN) ? 1 : ((b.S + b.CN > a.S + a.CN) ? -1 : 0));
                }
                break;
            case "classNumberSort":
                if (this.state.classNumberSort === "ASC") {
                    classes.sort((a, b) => (a.CLASS_NBR > b.CLASS_NBR) ? 1 : ((b.CLASS_NBR > a.CLASS_NBR) ? -1 : 0));
                } else {
                    classes.sort((b, a) => (a.CLASS_NBR > b.CLASS_NBR) ? 1 : ((b.CLASS_NBR > a.CLASS_NBR) ? -1 : 0));
                }
                break;
            case "dateSort":
                if (this.state.dateSort === "ASC") {
                    classes.sort((a, b) => (new Date(a.START_DT) > new Date(b.START_DT)) ? 1 : ((new Date(b.START_DT) > new Date(a.START_DT)) ? -1 : 0));
                } else {
                    classes.sort((b, a) => (new Date(a.START_DT) > new Date(b.START_DT)) ? 1 : ((new Date(b.START_DT) > new Date(a.START_DT)) ? -1 : 0));
                }
                break;
            case "locationSort":
                if (this.state.locationSort === "ASC") {
                    classes.sort((a, b) => (a.LOC_D > b.LOC_D) ? 1 : ((b.LOC_D > a.LOC_D) ? -1 : 0));
                } else {
                    classes.sort((b, a) => (a.LOC_D > b.LOC_D) ? 1 : ((b.LOC_D > a.LOC_D) ? -1 : 0));
                }
                break;
            default:
        }

        //page
        let i;
        let classesOnThisPage = [];
        let currentPage = this.state.page;

        if (currentPage * this.state.itemsPerPage > this.props.classes.length) {
            currentPage = Math.ceil(this.props.classes.length / this.state.itemsPerPage) - 1;
        }

        for (i = currentPage * this.state.itemsPerPage; i < (currentPage * this.state.itemsPerPage) + this.state.itemsPerPage; i++) {
            if (classes[i]) {
                classesOnThisPage.push(classes[i]);
            } else {
                break;
            }
        }

        //page selector
        let totalPages = Math.ceil(classes.length / this.state.itemsPerPage);
        let pages = [];
        for (i = 0; i < totalPages; i++) {
            pages.push(i);
        }

        return (
            <div>
                <nav aria-label="Page navigation">
                    <ul className="pagination mt-2 d-print-none">
                        <li className="page-item"><button disabled={this.state.page === 0} className="page-link" onClick={() => this.gotoPage(0)}>First</button></li>
                        <li className="page-item"><button disabled={this.state.page === 0} className="page-link" onClick={() => this.gotoPage(this.state.page - 1)}>Previous</button></li>
                        {pages.map((pageNumber) => { return (currentPage < 5 && pageNumber < 9) || (pageNumber > currentPage - 5 && pageNumber < currentPage + 5) || (currentPage > totalPages - 5 && pageNumber > totalPages - 10) ? <PageButton key={pageNumber} gotoPage={this.gotoPage} pageNumber={pageNumber} currentPage={currentPage} /> : null })}
                        <li className="page-item"><button disabled={this.state.page === totalPages - 1} className="page-link" onClick={() => this.gotoPage(this.state.page + 1)}>Next</button></li>
                        <li className="page-item"><button disabled={this.state.page === totalPages - 1} className="page-link" onClick={() => this.gotoPage(totalPages - 1)}>Last</button></li>
                        <button className="btn btn-secondary ml-5 d-print-none d-none d-lg-inline" onClick={window.print}><i className="fas fa-print"></i>&nbsp;Print</button>
                    </ul>
                </nav>
                <div className="d-print-none">
                    Sort by:
                <button className="mr-3" style={this.buttonToLink} id="btnCourseSort" onClick={this.handleChange}>Course {this.state.courseSort === "ASC" ? <i className="fas fa-sort-up"></i> : (this.state.courseSort === "DESC" ? <i className="fas fa-sort-down"></i> : <i className="fas fa-sort"></i>)}</button>
                    <button className="mr-3" style={this.buttonToLink} id="btnClassNumberSort" onClick={this.handleChange}>Class No. {this.state.classNumberSort === "ASC" ? <i className="fas fa-sort-up"></i> : (this.state.classNumberSort === "DESC" ? <i className="fas fa-sort-down"></i> : <i className="fas fa-sort"></i>)}</button>
                    <button className="mr-3" style={this.buttonToLink} id="btnDateSort" onClick={this.handleChange}>Start &amp; End Date {this.state.dateSort === "ASC" ? <i className="fas fa-sort-up"></i> : (this.state.dateSort === "DESC" ? <i className="fas fa-sort-down"></i> : <i className="fas fa-sort"></i>)}</button>
                    <button className="mr-3" style={this.buttonToLink} id="btnLocationSort" onClick={this.handleChange}>Location {this.state.locationSort === "ASC" ? <i className="fas fa-sort-up"></i> : (this.state.locationSort === "DESC" ? <i className="fas fa-sort-down"></i> : <i className="fas fa-sort"></i>)}</button>
                </div>

                {classesOnThisPage.map(cls => (
                    <ClassCardBig key={cls.CLASS_NBR} cls={cls} searchFilter={this.props.searchFilter} addCompare={this.props.addCompare} compares={this.props.compares} downrangeLocations={this.props.downrangeLocations} />
                ))}
                <nav aria-label="Page navigation">
                    <ul className="pagination mt-2 d-print-none">
                        <li className="page-item"><button disabled={this.state.page === 0} className="page-link" onClick={() => this.gotoPage(0)}>First</button></li>
                        <li className="page-item"><button disabled={this.state.page === 0} className="page-link" onClick={() => this.gotoPage(this.state.page - 1)}>Previous</button></li>
                        {pages.map((pageNumber) => { return (currentPage < 5 && pageNumber < 9) || (pageNumber > currentPage - 5 && pageNumber < currentPage + 5) || (currentPage > totalPages - 5 && pageNumber > totalPages - 10) ? <PageButton key={pageNumber} gotoPage={this.gotoPage} pageNumber={pageNumber} currentPage={currentPage} /> : null })}
                        <li className="page-item"><button disabled={this.state.page === totalPages - 1} className="page-link" onClick={() => this.gotoPage(this.state.page + 1)}>Next</button></li>
                        <li className="page-item"><button disabled={this.state.page === totalPages - 1} className="page-link" onClick={() => this.gotoPage(totalPages - 1)}>Last</button></li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default ClassesList;